// import React from "react";

// const Summary = () => {
//   return (
//     <>
//       <div className="bg-white rounded-lg shadow-lg md:p-10 p-5 mb-5 ">
//         <h1 className="text-sm text-gray-500 font-normal capitalize">Employee:</h1>
//         <h1 className="text-black font-bold text-base capitalize">all</h1>
//         <h1 className="text-sm text-gray-500 font-normal pt-5 capitalize">date:</h1>
//         <p className="text-gray-700">
//           Not defined <span>-Not defined </span>
//         </p>
//         <h1 className="text-sm text-gray-500 font-normal pt-5 capitalize">total</h1>
//         <h1 className="text-black font-bold text-base capitalize">0.00 undefined</h1>
//         <div className="grid md:grid-cols-3 grid-cols-2 text-sm text-gray-500 font-normal pt-8 capitalize">
//           <h1 className="">Task</h1>
//           <h1 className="">Finished tasks</h1>
//           <h1 className="">Total piece rate</h1>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Summary;








import React from "react";

const Summary = () => {
  const data = [
    {
      employee: "Employee 1",
      date: "2023-06-22",
      total: "100.00",
      task: "Task 1",
      finishedTasks: 5,
      totalPieceRate: "50.00"
    },
    {
      employee: "Employee 2",
      date: "2023-06-23",
      total: "200.00",
      task: "Task 2",
      finishedTasks: 10,
      totalPieceRate: "100.00"
    },
    {
      employee: "Employee 3",
      date: "2023-06-24",
      total: "300.00",
      task: "Task 3",
      finishedTasks: 15,
      totalPieceRate: "150.00"
    },
    {
      employee: "Employee 4",
      date: "2023-06-25",
      total: "400.00",
      task: "Task 4",
      finishedTasks: 20,
      totalPieceRate: "200.00"
    },
    {
      employee: "Employee 5",
      date: "2023-06-26",
      total: "500.00",
      task: "Task 5",
      finishedTasks: 25,
      totalPieceRate: "250.00"
    }
  ];

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  return (
    <div>
      {data.map((item, index) => (
        <div key={index} className="bg-white rounded-lg shadow-lg md:p-10 p-5 mb-5">
          <h1 className="text-sm text-gray-500 font-normal capitalize">Employee:</h1>
          <h1 className="text-black font-bold text-base capitalize">{item.employee}</h1>
          <h1 className="text-sm text-gray-500 font-normal pt-5 capitalize">Date:</h1>
          <p className="text-gray-700">
            {item.date ? formatDate(item.date) : "Not defined"} <span>{item.date ? `- ${formatDate(item.date)}` : "- Not defined"}</span>
          </p>
          <h1 className="text-sm text-gray-500 font-normal pt-5 capitalize">Total:</h1>
          <h1 className="text-black font-bold text-base capitalize">{item.total} undefined</h1>
          <div className="grid md:grid-cols-3 grid-cols-2 text-sm text-gray-500 font-normal pt-8 capitalize md:gap-0 gap-3">
            <div>
            <h1 className="">Task</h1>
            <h1 className="">{item.task}</h1>
            </div>





            <div>
            <h1 className="">Finished tasks</h1>
            <h1 className="">{item.finishedTasks}</h1>
            </div>

            <div>
            <h1 className="">Total piece rate</h1>
            <h1 className="">{item.totalPieceRate}</h1>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Summary;
